import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

export const C1LinkTheme: Components<Theme>['MuiLink'] = {
    defaultProps: {
        underline: 'hover',
        color: (theme) => (theme.palette.mode === 'dark'
            ? theme.palette.text.primary
            : theme.palette.primary.main),
        variant: 'body1',
    },
    styleOverrides: {
        root: {
            textDecorationColor: 'initial',
        },
    },
}
